// removed by extract-text-webpack-plugin
module.exports = {"this":"_3Pr13vYPSOov5ev6sk_Oeo","showModel":"_240-Si6ZzqKkkY95IJGYom"};


//////////////////
// WEBPACK FOOTER
// ./src/frame/ui/popup/WxSharePopup.scss
// module id = 602
// module chunks = 12